import { render, staticRenderFns } from "./b5.vue?vue&type=template&id=aae6e8ba&"
import script from "./b5.vue?vue&type=script&lang=js&"
export * from "./b5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports